module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/DDA3bm/tc-custom/9781685622572.jpg?1705688333538",
      "alt": "This image is the cover for the book Hounded"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Hounded\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', {
    staticStyle: {
      "margin-right": "0cm",
      "margin-left": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "margin": "0cm",
      "margin-bottom": ".0001pt",
      "text-align": "justify",
      "background": "white"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v("It is 2066, twenty-five years after the Immune Collapse decimated the world population. The survivors spend as much time as possible in VR rather than in the real world. ")])]), _c('p', {
    staticStyle: {
      "margin-right": "0cm",
      "margin-left": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "margin": "0cm",
      "margin-bottom": ".0001pt",
      "text-align": "justify",
      "background": "white"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin-right": "0cm",
      "margin-left": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "margin": "0cm",
      "margin-bottom": ".0001pt",
      "text-align": "justify",
      "background": "white"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v("Vic Malone is a newly-promoted detective assigned to robbery-homicide in the Brooklyn Police Department. He finds himself tangled up in a case that involves murder, illegal software, blackmail, and the mob. Fortunately for Vic, his partner is Officer Louis, a Neo-9. Neo-9s are genetically enhanced dogs, and Louis’ mom was a black Labrador. With hidden talents and a secret life, he is far more than just a K-9 sidekick. ")])]), _c('p', {
    staticStyle: {
      "margin-right": "0cm",
      "margin-left": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "margin": "0cm",
      "margin-bottom": ".0001pt",
      "text-align": "justify",
      "background": "white"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin-right": "0cm",
      "margin-left": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "margin": "0cm",
      "margin-bottom": ".0001pt",
      "text-align": "justify",
      "background": "white"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v("With the help of the police, the FBI, self-aware AI avatars, and other Neo-9s, Louis and Vic must solve the case before the shadowy forces responsible for the crimes can find and put them down. ")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Frederic Martini\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Frederic Martini has always loved dogs and science fiction. He has published in the fields of human anatomy and physiology, vertebrate evolution, marine science, and history. "), _c('em', [_vm._v("Hounded")]), _vm._v(" reflects his experiences with dogs, high-tech science, and science fiction.")])]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "text-align": "justify"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Dr. Martini’s hobbies include blue-water sailing, scuba, submersible diving, and trying to keep his two young labradoodle/border collie crosses from destroying the furniture. ")])]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "text-align": "justify"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("More information on the author can be found at www.fredericmartini.com. ")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0